/* RN 2027 W13 brand separation (30 Oct 2026). Passive link helper: inside a brand (White Doe, Bruxlings,
   Ripleys Nest home) links to shared pages open that brand's view, and dead ends (home page, all products,
   vendor/type lists) lead to the brand's front door. It only changes <a href> (and drops vendor/type links to plain
   text); it never touches forms, buttons, add to basket, the basket or checkout. Same map as snippets/rn-world-url.liquid. */
(function () {
  var cfg = window.RN_WORLD || {};
  var w = cfg.world;
  if (w !== 'doe' && w !== 'brux' && w !== 'home') return;
  var front = cfg.front;
  var VIEW = {
    '/pages/contact': ['/pages/contact', 'contact'],
    '/pages/about': ['/pages/about', 'about'],
    '/pages/about-us': ['/pages/about', 'about'],
    '/pages/faq': ['/pages/faq', 'faq'],
    '/pages/shipping': ['/pages/shipping', 'quick-support-v8'],
    '/pages/returns': ['/pages/returns', 'quick-support-v8'],
    '/pages/help-and-order-support': ['/pages/help-and-order-support', 'quick-support-v8'],
    '/pages/help-support': ['/pages/help-and-order-support', 'quick-support-v8'],
    '/pages/delivery-information': ['/pages/delivery-information', 'quick-support-v8'],
    '/pages/returns-and-refunds-info': ['/pages/returns-and-refunds-info', 'quick-support-v8'],
    '/pages/shipping-returns': ['/pages/shipping', 'quick-support-v8'],
    '/pages/shipping-delivery': ['/pages/shipping', 'quick-support-v8'],
    '/policies/shipping-policy': ['/pages/shipping', 'quick-support-v8'],
    '/pages/order-tracking': ['/pages/order-tracking', 'order-tracking-light-v4'],
    '/pages/pet-memorial-gift-chooser': w === 'doe' ? ['/pages/pet-memorial-gift-chooser', 'pet-memorial-gift-chooser-v4'] : null,
    '/pages/terms-conditions': ['/pages/terms-conditions', 'terms'],
    '/policies/terms-of-service': ['/pages/terms-conditions', 'terms'],
    '/policies/legal-notice': ['/pages/terms-conditions', 'terms'],
    '/pages/privacy-policy': ['/pages/privacy-policy', 'privacy'],
    '/policies/privacy-policy': ['/pages/privacy-policy', 'privacy'],
    '/policies/refund-policy': ['/pages/returns-and-refunds-info', 'refund'],
    '/policies/contact-information': ['/pages/contact', 'contact']
  };
  var FRONT = { '/': 1, '/collections': 1, '/collections/all': 1 };
  var host = location.host;

  function fix(a) {
    if (!a || a.dataset.rnKeep !== undefined) return;
    var raw = a.getAttribute('href');
    if (!raw || raw.charAt(0) === '#' || /^(mailto|tel|javascript):/i.test(raw)) return;
    var u;
    try { u = new URL(raw, location.href); } catch (e) { return; }
    if (u.host !== host && u.host !== 'ripleysnest.co.uk') return;
    var p = u.pathname.replace(/\/$/, '') || '/';
    if (/^\/collections\/(vendors|types)$/.test(p)) {
      var s = document.createElement('span');
      s.className = a.className;
      s.textContent = a.textContent;
      a.replaceWith(s);
      return;
    }
    if (FRONT[p]) {
      a.setAttribute('href', front);
      return;
    }
    if (p === '/cart' || p === '/search') {
      if (!u.searchParams.get('view')) {
        u.searchParams.set('view', w);
        a.setAttribute('href', u.pathname + u.search + u.hash);
      }
      return;
    }
    var v = VIEW[p];
    if (v && !u.searchParams.get('view')) {
      a.setAttribute('href', v[0] + '?view=' + v[1] + '-' + w + u.hash);
    }
  }

  function hideForeignDrawerLinks() {
    var el = document.getElementById('rn-menu-foreign');
    if (!el) return;
    var data;
    try { data = JSON.parse(el.textContent); } catch (e) { return; }
    var urls = data.urls || [];
    var titles = (data.titles || []).map(function (t) { return t.trim().toLowerCase(); });
    document.querySelectorAll('#MenuDrawer li').forEach(function (li) {
      var own = li.querySelector(':scope > a, :scope > details > summary');
      if (!own) return;
      var href = own.getAttribute('href') || own.getAttribute('data-link');
      var text = own.textContent.trim().toLowerCase();
      if ((href && urls.indexOf(href) > -1) || titles.indexOf(text) > -1) li.hidden = true;
    });
  }

  function run(root) {
    (root || document).querySelectorAll('a[href]').forEach(fix);
  }

  function start() {
    run();
    hideForeignDrawerLinks();
    // Links added later (predictive search, drawers): fix at the moment they are used.
    document.addEventListener('pointerdown', function (e) { fix(e.target.closest && e.target.closest('a[href]')); }, true);
    document.addEventListener('focusin', function (e) { fix(e.target.closest && e.target.closest('a[href]')); }, true);
    document.addEventListener('click', function (e) { fix(e.target.closest && e.target.closest('a[href]')); }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
